import React from "react";

import styles from "../../styles/Home.module.scss";
import Header from "../../components/Header";
// import Hero from "../components/Hero";
// import ScrollHero from "../components/ScrollHero";
import { HomeSectionOne, HomeSectionTwo, HomeSectionThree, HomeSectionFour, HomeSectionFive } from "./HomeContants";

import HeaderSection from "../../components/HeaderSection";
import SplitSection from "../../components/SplitSection";
import ExploreSection from "../../components/ExploreSection";
import PreviewSection from '../../components/PreviewSection';
import FooterSection from "../../components/FooterSection";

const Home = () => {
  return (
    <div className={styles.home}>
      <Header />
      <HeaderSection {...HomeSectionOne} />
      <SplitSection {...HomeSectionTwo}/>
      <ExploreSection {...HomeSectionThree}/>
      <PreviewSection {...HomeSectionFour}/>
      <FooterSection {...HomeSectionFive} />
    </div>
  );
}


export default Home;
